import {
  COUNTRY_CODE,
  CURRENT_CITY,
  CURRENT_DISTRICT,
  CURRENT_STATE,
  DialCodes,
  DOB,
  EMAIL,
  FULL_NAME,
  LAST_NAME,
  PINCODE,
  PREFERRED_LANGUAGE,
  SELECTED_GENDER,
  SELECTED_OCCUPATION,
  WHATSAPP_INFO_STATUS
} from '@nw/shared/config';

import { getPreferredLanguagesEnums } from '../LanguageUtils';

export const getRequestObjectToVerifyMobileOTP = (
  phoneNumber: string,
  countryCode: string,
  clientId: string,
  otpValue: string,
  acceptedTandC: boolean,
  customId?: string
) => {
  const requestObject = {
    phone_number: phoneNumber,
    country_code: countryCode,
    client_id: clientId,
    otp_value: otpValue,
    accepted_tnc: acceptedTandC,
    custom_id: customId
  };

  return requestObject;
};

export const getUpdateProfileRequestObject = (
  userProfileData,
  values
): Record<string, any> => {
  let updateProfileRequestObject = {};
  Object.keys(values).map((eachKey) => {
    if (
      eachKey === FULL_NAME &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        name: values[eachKey]
      };
    if (
      eachKey === LAST_NAME &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        last_name: values[eachKey]
      };
    if (
      eachKey === EMAIL &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined &&
      values[eachKey] !== userProfileData.email
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        email: values[eachKey]
      };
    if (
      eachKey === DOB &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        dob: values[eachKey]
      };
    if (
      eachKey === SELECTED_OCCUPATION &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        occupation: values[eachKey]
      };
    if (
      eachKey === SELECTED_GENDER &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        gender: values[eachKey]
      };
    if (
      eachKey === CURRENT_CITY &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        current_city: values[eachKey]
      };
    if (
      eachKey === CURRENT_STATE &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        current_state: values[eachKey]
      };
    if (
      eachKey === CURRENT_DISTRICT &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        current_district: values[eachKey]
      };
    if (
      eachKey === PINCODE &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined
    )
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        pincode: values[eachKey]
      };
    if (
      eachKey === PREFERRED_LANGUAGE &&
      values[eachKey] !== '' &&
      values[eachKey] !== undefined &&
      typeof values[eachKey] === 'string'
    ) {
      const preferredLanguages = getPreferredLanguagesEnums(values[eachKey]);
      updateProfileRequestObject = {
        ...updateProfileRequestObject,
        preferredLanguages: preferredLanguages
      };
    }
  });
  return updateProfileRequestObject;
};

export const getAcceptedTandC = (productInfo) => {
  const tncToAcceptFields = productInfo?.form.allFormFields?.filter(
    (eachField) => {
      return eachField.isTNC;
    }
  );
  const acceptedTncs = tncToAcceptFields?.map((eachField) => {
    if (eachField.tncEnum) {
      return eachField.tncEnum;
    }
  });
  return acceptedTncs && acceptedTncs[0] ? acceptedTncs : [];
};

export const getHiddenFormFieldsValues = (fields, values) => {
  const hiddenFields = fields?.filter((eachField) => {
    return eachField.isHidden;
  });
  let hiddenFormFieldsValues = {};
  hiddenFields?.forEach((element) => {
    if (element.type === WHATSAPP_INFO_STATUS) {
      hiddenFormFieldsValues[element.field] = values.whatsappInfoStatus
        .toString()
        .toUpperCase();
    }
    if (element.type === COUNTRY_CODE) {
      hiddenFormFieldsValues[element.field] = DialCodes.india;
    }
  });
  return hiddenFormFieldsValues;
};

export const getCreateOrderRequestObject = (
  inviteCode,
  productCode,
  userDetails,
  extraInfoBasedOnProductConfig,
  amountToBePaidInLeastSubUnit,
  acceptedTnc
) => ({
  invite_code: inviteCode,
  product_code: productCode,
  user_details: userDetails,
  extra_info_based_on_product_config: extraInfoBasedOnProductConfig,
  amount_to_be_paid_in_least_subunit: amountToBePaidInLeastSubUnit,
  accepted_tnc: acceptedTnc
});

export const getSegmentApiRequestObject = (event, eventData, orderId) => ({
  event,
  event_data: eventData,
  order_id: orderId
});
